import { Advertisement } from "@adgate/common/types/advertisement.type";
import { BaseObject } from "@adgate/common/types/base-object.type";

export class Creativity extends Advertisement
{
    public static OBJECT_TYPE:number = 3;

    campaignId!: number;
    placementName!: string;
    lastModified!: number;
    channelFamilies: BaseObject[] = [];
    countries: BaseObject[] = [];
}
